import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { AuthContext } from "../../routes/AuthContext";
import { toast } from "react-toastify";


function Login() {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailOrPhone.trim() || !password.trim()) {
      toast.warn("⚠️ Fields cannot be empty.");
      return;
    }

    const isEmail = /^[^@]+@[^@]+\.[^@]+$/.test(emailOrPhone);
    const isPhone = /^[0-9]{10}$/.test(emailOrPhone);

    if (!isEmail && !isPhone) {
      toast.error("⚠️ Enter a valid email or 10-digit mobile number.");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}customer_login`;
    const formData = new FormData();
    formData.append("password", password.trim());
    formData.append("login_flag", "1");

    if (isEmail) {
      formData.append("email", emailOrPhone.trim());
    } else {
      formData.append("mobile_number", emailOrPhone.trim());
    }

    setIsLoading(true);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.api_success) {
        login(data.token, data.customer);
        toast.success(`✅ Welcome, ${data.customer.first_name}!`);
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 1000);
      } else {
        toast.error(`❌ ${data.message || "Login failed"}`);
      }
    } catch (error) {
      console.error(error);
      toast.error("🚨 Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container d-flex justify-content-center align-items-center">
      <div className="login-box">
        <h1 className="login-title">Welcome Back</h1>
        <p className="login-subtitle">
          Please enter your credentials to log in.
        </p>
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Email address or Mobile number"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
        <div className="login-links text-center">
          <Link to="/forgot-password" className="text-decoration-none">
            Forgot password?
          </Link>
          <span className="mx-2">|</span>
          <Link to="/register" className="text-decoration-none">
            Sign up
          </Link>
        </div>
      </div>
     
    </div>
  );
}

export default Login;